import { useEffect, useState, useRef } from "react";
import { FaArrowRight, FaCaretDown } from "react-icons/fa";
import { HiOutlineUsers } from "react-icons/hi";
import { IoShieldCheckmark, IoClose } from "react-icons/io5";
import { CgFileDocument } from "react-icons/cg";
import { TbBulb } from "react-icons/tb";
import Calendar from "react-calendar";
import { useClickOutside } from "../pages/Travel-New";
export default function SoloTravelerModal({
  isOpen,
  onClose,
  soloData,
  handleSoloChange,
  formatPassport,
  formatCNIC,
  validateCNIC,
  type,
  onSave,
}) {
  const [animate, setAnimate] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const isValidPassport = (v) => /^[A-Z]{2}[0-9]{7}$/.test(v);

  const startRef = useRef(null);
  useClickOutside(startRef, () => setShowCalendar(false));
  const [expiryDate, setExpiryDate] = useState(null);
  const relations = [
    "Father",
    "Mother",
    "Spouse",
    "Brother",
    "Sister",
    "Son",
    "Daughter",
  ];
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setAnimate(true), 10);
    } else {
      setAnimate(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;
  const handleSelect = (date) => {
    setExpiryDate(date);
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    handleSoloChange("passport_expiry", formattedDate);
    setShowCalendar(false);
  };
  const handleSave = () => {
    onSave();
  };
  console.log(type);
  return (
    <div
      className={`fixed inset-0 z-50 px-2 flex items-center justify-center bg-black/70 transition-opacity duration-300  ${
        animate ? "opacity-100" : "opacity-0"
      }`}
      onClick={onClose}
    >
      {/* Modal Box */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white w-full max-w-lg rounded-2xl shadow-lg p-3 relative transform transition-all duration-300 max-h-[90vh] overflow-y-auto ${
          animate
            ? "opacity-100 scale-100 translate-y-0"
            : "opacity-0 scale-95 translate-y-4"
        }`}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-2  hover:text-black"
        >
          <IoClose className="text-gray-600 h-6 w-6" />
        </button>
        {/* <p className="flex items-center justify-evenly bg-[#fed40c] font-semibold text-black text-sm! p-2.5 rounded-lg! w-44 absolute -top-5 left-1/2 transform -translate-x-1/2 ">
          {" "}
          <FaRegUser className="inline-block mr-2" />
          SOLO TRAVELLER
        </p> */}
        <div className="flex items-center justify-around mb-2">
          <div className="font-normal text-black">
            <h5 className="font-bold! mb-0 ">{type} Traveller Details</h5>
            <span className="text-xs! text-gray-600">
              Add passport and beneficiary information to continue.
            </span>{" "}
          </div>
          <div className="w-16 h-16 bg-[#fef8ec]  rounded-full!">
            <img src="/passport.png" alt="Passport" className="w-full h-full" />
          </div>
        </div>
        <div className="bg-[#fef8ec]  flex items-center gap-3 ring ring-[#fed40c] py-2 px-3 rounded-xl">
          <IoShieldCheckmark className="text-amber-500 h-14 w-14" />

          <div className="text-black flex-1 text-sm! h-14">
            <h6 className="font-semibold leading-tight">
              Passport is required
            </h6>
            <p className="text-xs! text-black">
              We only need your passport number and expiry date.
            </p>
          </div>
        </div>
        {/* Passport */}

        <div className="flex items-center gap-3 rounded-xl mt-2">
          <CgFileDocument className="text-black h-12 w-12 bg-amber-200 p-2.5 rounded-full!" />

          <div className="text-black flex-1 h-12">
            <h6 className="font-bold!">Passport Details</h6>
            <p className="text-xs! text-gray-700">
              Enter your passport information.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 ">
          {/* Passport Number */}
          <div className="w-1/2">
            <label className="text-sm! font-medium">Passport Number</label>
            <input
              type="text"
              value={soloData.passport}
              placeholder="Enter Full Number"
              maxLength={9}
              onChange={(e) =>
                handleSoloChange("passport", formatPassport(e.target.value))
              }
              className={`w-full p-2 text-xs! outline outline-amber-500 focus-visible:outline-amber-500! rounded-lg ${
                soloData.passport && !isValidPassport(soloData.passport)
                  ? "border-red-500"
                  : "border-amber-500"
              }`}
            />
          </div>

          {/* Expiry Date */}
          <div className="w-1/2">
            <label className="text-sm! font-medium">Expiry Date</label>

            <div className="relative">
              <div
                className="flex items-center justify-between outline outline-amber-500  rounded-lg px-3 py-2 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowCalendar(!showCalendar);
                }}
              >
                <input
                  type="text"
                  className="w-full outline-none text-xs! font-medium"
                  placeholder="DD - MM - YYYY"
                  value={
                    expiryDate
                      ? (() => {
                          const d = new Date(expiryDate);
                          const day = String(d.getDate()).padStart(2, "0");
                          const month = String(d.getMonth() + 1).padStart(
                            2,
                            "0",
                          );
                          const year = d.getFullYear();
                          return `${day} - ${month} - ${year}`;
                        })()
                      : ""
                  }
                  readOnly
                />
                <FaCaretDown className="text-amber-500" />
              </div>

              {showCalendar && (
                <div className="expiry-popup" ref={startRef}>
                  <Calendar
                    onChange={handleSelect}
                    value={expiryDate}
                    minDate={new Date()}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Error Message */}
        </div>
        {soloData.passport && !isValidPassport(soloData.passport) && (
          <p className="text-red-500 text-xs! mt-1">Invalid passport number</p>
        )}

        {/* Name */}
        <div className=" p-3 bg-[#fef8ec]  rounded-xl! ring ring-[#fed40c] mt-3">
          <div className="flex items-center gap-3 rounded-xl pb-2">
            <HiOutlineUsers className="text-black h-12 w-12 bg-amber-200 p-2.5 rounded-full!" />

            <div className="text-black flex-1 h-12">
              <h6 className="font-bold!">Beneficary Details</h6>
              <p className="text-xs! text-gray-700">
                A person who will be notified in case of emergency or claim.
              </p>
            </div>
          </div>
          <div className="my-2">
            <label className="text-sm! font-semibold">
              Beneficiary Full Name
            </label>
            <input
              type="text"
              value={soloData.beneficiaryName}
              placeholder="Enter Full name"
              onChange={(e) =>
                handleSoloChange("beneficiaryName", e.target.value)
              }
              className="w-full bg-white p-2 text-xs! rounded-lg outline outline-amber-500 focus-visible:outline-amber-500!"
            />
          </div>
          <div className="mb-2 ">
            <label className="text-sm! font-semibold mb-1">Relation</label>
            <div className="flex flex-wrap gap-2 mb-2">
              {relations.map((rel) => (
                <button
                  key={rel}
                  type="button"
                  onClick={() => handleSoloChange("relation", rel)}
                  className={`px-3 py-1 rounded-full! text-xs! border transition ${
                    soloData.relation === rel
                      ? "bg-black text-yellow-400 border-black"
                      : "bg-white text-black border-gray-300"
                  }`}
                >
                  {rel}
                </button>
              ))}
            </div>
          </div>
          {/* CNIC */}
          <div className="mb-2">
            <label className="text-xs! font-semibold">CNIC</label>
            <input
              type="text"
              value={soloData.cnic}
              placeholder="Enter 13-digit CNIC"
              onChange={(e) =>
                handleSoloChange("cnic", formatCNIC(e.target.value))
              }
              className={`w-full bg-white p-2 text-xs! border  focus-visible:outline-none focus-visible:border-amber-500! rounded-lg ${
                soloData.cnic && !validateCNIC(soloData.cnic)
                  ? "border-red-500"
                  : "border-amber-500"
              }`}
            />

            {soloData.cnic && !validateCNIC(soloData.cnic) && (
              <p className="text-red-500 text-xs! mt-1">Invalid CNIC format</p>
            )}
          </div>

          {/* Relation */}

          <div className="mt-2 text-xs! bg-yellow-100  px-3 py-2 rounded-lg text-black">
            <TbBulb className="inline-block mr-1 bg-amber-200 w-8 h-8 text-black rounded-full! p-1" />
            <strong>Tip:</strong> Accurate beneficiary details help process your
            claim faster.
          </div>
        </div>

        <div className="flex gap-3 mt-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 text-sm font-semibold text-gray-800 bg-white outline outline-gray-400! rounded-2xl! hover:bg-gray-50 active:scale-95 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-2 py-3 text-sm font-bold text-black bg-amber-400 hover:bg-amber-500 active:scale-95 rounded-xl! flex items-center justify-center gap-2 transition-all"
          >
            Save & Close
            <FaArrowRight className="" />
          </button>
        </div>
      </div>
    </div>
  );
}
